import reportWebVitals from 'reportWebVitals';

import { loadConfiguration } from 'lib/configuration';

loadConfiguration()
  .then(() => import('./appEntry'))
  .catch((err: unknown) => {
    document.body.innerHTML = `Failed to load environment configuration.<br>${err}`;
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
